import { useTranslation } from "react-i18next";
import OrdersTable from "@/components/organisms/OrdersTable";
import { DEFAULT_ORDER_COLUMNS } from "@/components/organisms/OrdersTable/const/default";
import OrdersFilter from "@/components/organisms/OrdersTable/OrdersFilter";
import Heading from "@/components/atoms/Heading";
import OrderSchedule from "@/components/organisms/OrderSchedule";
import styles from "./styles.module.css";
import { Box } from "@mantine/core";
import { useAuth } from "@/contexts/AuthContext";
import { useGetCompanyById } from "@/services/Company";

export default function MyOrders() {
  const { t } = useTranslation();
  const { currentCompany } = useAuth();
  const { data: company } = useGetCompanyById(currentCompany?.companyId as number, {
    enabled: !!currentCompany?.companyId,
  });

  return (
    <>
      <title>{`Reviver - ${t("dashboard:myOrders")}`}</title>
      <meta name="description" content={`Reviver - ${t("dashboard:myOrders")}`} />
      <Box className={styles.contentRoot}>
        <Heading order={1} styleOrder={4} strong mb={24} mt={32}>
          {t("common:orders")}
        </Heading>
        <OrdersFilter />
        <OrdersTable visibleColumns={DEFAULT_ORDER_COLUMNS} />
        {company?.isOrderPlanningEnabled && (
          <>
            <Heading order={1} styleOrder={4} strong mb={24} mt={32}>
              {t("orders:orderCalendar")}
            </Heading>
            <OrderSchedule />
          </>
        )}
      </Box>
    </>
  );
}
